<template>
  <div class="content-useful-files">
    <BannerUsefulFilesSection />
    <UserfulFilesIntroSection />
    <UsefulFilesCardsSections />
  </div>
</template>

<script lang="ts">
import BannerUsefulFilesSection from '@/components/UsefulFilesPage/sections/BannerUsefulFilesSection.vue'
import UsefulFilesCardsSections from '@/components/UsefulFilesPage/sections/UsefulFilesCardsSections.vue'
import UserfulFilesIntroSection from '@/components/UsefulFilesPage/sections/UserfulFilesIntroSection.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    BannerUsefulFilesSection,
    UsefulFilesCardsSections,
    UserfulFilesIntroSection
  }
})
export default class UsefulFilesView extends Vue {}
</script>

<style lang="scss">
.content-useful-files {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
}
</style>
